<template>
  <tri-manager
    :table-fetch="tableFetch"
    :table-fetch-active="tableFetchActive"
    :table-archive="tableArchive"
    :table-restore="tableRestore"
    :table-columns="tableColumns"
  />
</template>

<script>
import TriManager from "@/components/Tri/TriManager";
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";

export default {
  components: {
    TriManager,
  },
  data: () => ({
    tableColumns: [
      {
        field: "category",
        label: "Category",
      },
      {
        field: "code",
        label: "Code",
      },
      {
        field: "description",
        label: "Description",
      },
    ],
  }),
  methods: {
    async tableFetch() {
      // Fetch master asset codes
      return await OrderOperationClaimServiceService.all({
        firm_id: this.$store.state.Auth.user.firmId,
        status: 1,
        is_template: 1,
      });
    },
    async tableFetchActive(payload) {
      // Fetch active asset codes
      return await OrderOperationClaimServiceService.all({
        firm_id: this.$store.state.Auth.user.firmId,
        tag_id: payload.contract_type_tag_id || undefined,
        contract_id: payload.contract_id || undefined,
        status: payload.contract_id ? 1 : undefined,
        is_template: payload.contract_id ? undefined : 1,
      });
    },
    async tableArchive(payload) {
      // // Archive asset-contractType relationships
      // if (payload.contract_type_tag_id) {
      //   await AssetService.archiveContractTypeTags({
      //     codeId: payload.id,
      //     contract_type_tag_ids: [payload.contract_type_tag_id],
      //   });
      // }
      // // Archive asset-contract relationships
      // if (payload.contract_id) {
      //   await AssetService.archiveContracts({
      //     codeId: payload.id,
      //     contract_ids: [payload.contract_id],
      //   });
      // }
    },
    async tableRestore(payload) {
      // // Restore asset-contractType relationships
      // if (payload.contract_type_tag_id) {
      //   await AssetService.restoreContractTypeTags({
      //     codeId: payload.id,
      //     contract_type_tag_ids: [payload.contract_type_tag_id],
      //   });
      // }
      // // Restore asset-contract relationships
      // if (payload.contract_id) {
      //   await AssetService.restoreContracts({
      //     codeId: payload.id,
      //     contract_ids: [payload.contract_id],
      //   });
      // }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/organizationData/organizationSettingsRates.vue